import showNotification from './showNotification';

export default function showErrorNotification(data){
  return showNotification('danger', 'Ошибка', `${data.msg}`);
}
